export type SubscriptionState = {
  expiresOn: string | null;
  formattedExpiresOn: string;
  daysLeft: number | null;
  isExpired: boolean;
  isExpiringSoon: boolean;
};

const WARNING_DAYS = 7;

function toLocalDateStart(value: Date) {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate());
}

function parseDateOnly(value?: string | null) {
  if (!value) return null;
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return null;
  const parsed = new Date(year, month - 1, day);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
}

export function formatRuDate(value?: string | null) {
  const parsed = parseDateOnly(value);
  if (!parsed) return "—";
  return parsed.toLocaleDateString("ru-RU");
}

export function formatDaysLeft(days: number) {
  const abs = Math.abs(days);
  const lastTwo = abs % 100;
  const lastOne = abs % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return `${days} дней`;
  if (lastOne === 1) return `${days} день`;
  if (lastOne >= 2 && lastOne <= 4) return `${days} дня`;
  return `${days} дней`;
}

export function getSubscriptionState(expiresOn?: string | null): SubscriptionState {
  const expiresDate = parseDateOnly(expiresOn);
  if (!expiresDate) {
    return {
      expiresOn: expiresOn ?? null,
      formattedExpiresOn: "—",
      daysLeft: null,
      isExpired: false,
      isExpiringSoon: false,
    };
  }

  const today = toLocalDateStart(new Date());
  const expires = toLocalDateStart(expiresDate);
  const daysLeft = Math.round((expires.getTime() - today.getTime()) / 86400000);
  const isExpired = daysLeft < 0;

  return {
    expiresOn: expiresOn ?? null,
    formattedExpiresOn: formatRuDate(expiresOn),
    daysLeft,
    isExpired,
    isExpiringSoon: !isExpired && daysLeft <= WARNING_DAYS,
  };
}
